// extracted by mini-css-extract-plugin
export var button = "TeamMember-module--button--17e8c";
export var container = "TeamMember-module--container--db107";
export var content = "TeamMember-module--content--fec5e";
export var decor = "TeamMember-module--decor--fa7d2";
export var details = "TeamMember-module--details--6c595";
export var heading = "TeamMember-module--heading--7b33b";
export var image = "TeamMember-module--image--7d0de";
export var lineAbove = "TeamMember-module--lineAbove--87dd7";
export var relativeWrapper = "TeamMember-module--relativeWrapper--8ad0f";
export var title = "TeamMember-module--title--53b46";